import { useTranslations } from 'next-intl'
import { renderHtmlTagMap } from '~/context/localisation'

/**
 * Parses HTML tags inside messages.
 * To be used in places where we expect tags to be present in the messages.
 * Please provide the full message key.
 */
export function useParseRichTextMessage(namespace = '') {
  const t = useTranslations(namespace as never)
  const parser = (key: string, values?: Record<string, any>): string => {
    return t.rich(
      key as never,
      {
        ...renderHtmlTagMap,
        ...values,
      } as unknown as undefined
    ) as string
  }

  return { parser }
}
